import React from "react";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";

const OtpInputBox = ({ value, onChange, onKeyDown, inputRef, onPaste }) => {
  return (
    <TextField
      inputProps={{
        style: {
          textAlign: "center",
          fontSize: "28px",
          color: "475467",
          fontWeight: "bold",
          maxWidth: 34,
          height: 34,
        },
        maxLength: 1,
      }}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      inputRef={inputRef}
      onPaste={onPaste}
      variant="outlined"
      size="small"
      type="text"
      sx={{
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderWidth: "2px",
            borderColor: "#D0D5DD",
            borderRadius: "10px",
          },
          "&:hover fieldset": {
            borderColor: "#a9a9a9", // Slightly darker on hover
            borderRadius: "10px",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#808080", // Darker when focused
            borderRadius: "10px",
          },
        },
      }}
    />
  );
};

OtpInputBox.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  inputRef: PropTypes.func.isRequired,
  onPaste: PropTypes.func,
};

export default OtpInputBox;
